import { Plus } from 'lucide-react';
import { Button } from '@/components/common/Button';

interface NewChatButtonProps {
  onClick: () => void;
  disabled?: boolean;
  variant?: 'funcionarios' | 'oposiciones';
}

export function NewChatButton({ onClick, disabled, variant = 'funcionarios' }: NewChatButtonProps) {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      className={`w-full justify-center gap-2 hover:opacity-90 transition-opacity text-white font-medium ${
        variant === 'oposiciones'
          ? 'bg-gradient-to-r from-violet-700 to-violet-500'
          : 'bg-gradient-to-r from-primary to-secondary'
      }`}
    >
      <Plus className="h-5 w-5" />
      Nueva consulta
    </Button>
  );
}
